/**
 * Events API helpers.
 */

import { compressImageForUpload } from './mediaCompress';
import { uploadFormData } from './uploadHelpers';

export async function getEvents(attendingOnly = false) {
  const url = attendingOnly ? '/api/events?attending=true' : '/api/events';
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch events');
  return res.json();
}

export async function getEvent(eventId) {
  const res = await fetch(`/api/events/${eventId}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch event');
  return res.json();
}

export async function getEventAttendees(eventId) {
  const res = await fetch(`/api/events/${eventId}/attendees`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch attendees');
  return res.json();
}

export async function createEvent(data) {
  const res = await fetch('/api/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create event');
  }
  return res.json();
}

export async function updateEvent(eventId, data) {
  const res = await fetch(`/api/events/${eventId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to update event');
  }
  return res.json();
}

export async function deleteEvent(eventId) {
  const res = await fetch(`/api/events/${eventId}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to delete event');
  }
  return res.json();
}

export async function attendEvent(eventId, status = 'going') {
  const res = await fetch(`/api/events/${eventId}/attend`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status }),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to attend event');
  }
  return res.json();
}

export async function leaveEvent(eventId) {
  const res = await fetch(`/api/events/${eventId}/leave`, {
    method: 'POST',
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to leave event');
  }
  return res.json();
}

export async function inviteToEvent(eventId, userId) {
  const res = await fetch(`/api/events/${eventId}/invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId }),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to invite');
  }
  return res.json();
}

/** Upload image and set event avatar_url (creator). */
export async function uploadEventAvatar(eventId, file, options = {}) {
  const compressed = await compressImageForUpload(file);
  const formData = new FormData();
  formData.append('file', compressed);
  formData.append('event_id', String(eventId));
  try {
    return await uploadFormData('/api/media/event-avatar', formData, {
      onProgress: options.onProgress,
    });
  } catch (err) {
    throw new Error(err.message || 'Failed to upload event picture');
  }
}
